import { Outlet } from "@remix-run/react";
import { useEffect } from "react";

import { CartSidebar } from "~/modules/Cart/CartSidebar";

import { AmbientBackground } from "./components/AmbientBackground";
import { FloatingActions } from "./components/FloatingActions";
import { LandingHeader } from "./components/LandingHeader";
import { LandingNewFooter } from "./components/LandingNewFooter";
import { initExperienceLevel } from "./lib/experienceLevel";

export default function LandingLayout() {
  // Puntaje de capacidad + sondas de runtime. Los overrides duros ya los resolvió el
  // script inline de `root.tsx` antes del primer pintado; esto sólo puede DEGRADAR.
  // Va acá y no en el layout raíz porque el nivel de experiencia es, por ahora, una
  // decisión de la superficie pública: la app autenticada no lo consume.
  useEffect(() => initExperienceLevel(), []);

  return (
    <div
      data-landing-surface
      className="font-landing relative flex min-h-screen flex-col bg-transparent"
      style={{ overflowX: "clip" }}
    >
      <AmbientBackground />
      <LandingHeader />
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
      <LandingNewFooter />
      <CartSidebar />
      <FloatingActions />
    </div>
  );
}
